<template>
  <div
    @contextmenu.prevent
    class="iframe-container"
    style="display: flex; flex-direction: column; justify-content: center; align-items: center;"
  >
    <iframe
      :src="iframeUrl"
      style="
        background-color: #fff; 
        background-color: #fff;
        border: 3px dotted #ccc;
        height: 37rem;
      "
      width="300"
    />
    <div class="iframe-overlay" />
  </div>
</template>

<script>
export default {
  name: 'CreativeModalAddInfeed',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    mainImageUrl: {
      type: String,
      default: '',
    },
    iconImageUrl: {
      type: String,
      default: '',
    },
    sponsoredBy: {
      type: String,
      default: '',
    },
    cta: {
      type: String,
      default: '',
    },
    lpUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    iframeUrl() {
      const baseUrl = (() => {
        if (process.env.NODE_ENV === 'production') {
          return 'https://creative-preview.geo-logic.jp'
        }
        return 'https://creative-preview-dev.geo-logic.jp'
      })()
      return `${baseUrl}?title=${encodeURIComponent(
        this.title,
      )}&description=${encodeURIComponent(this.description)}&iconAssetUrl=${
        this.iconImageUrl
      }&mainAssetUrl=${this.mainImageUrl}&sponsored=${encodeURIComponent(
        this.sponsoredBy,
      )}&cta=${encodeURIComponent(this.cta)}&lpUrl=${encodeURIComponent(
        this.lpUrl,
      )}`
    },
  },
}
</script>

<style scoped lang="scss">
.iframe-container {
  position: relative;
}
.iframe-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 10;
}
.wrapper {
  border: 1px dotted #666;
  height: 100px;
  transition: height 0.5s linear;
}

p {
  margin-top: 17px;
  padding-left: 20px;
}

.error-message {
  position: relative;
  top: -17px;
  color: red;
  font-size: 12px;
}

.errorStringCount {
  color: red;
}
</style>
